import { useEffect, useState } from 'react';

import { IPropsPositionAll } from '../../../../../../../utils/@types/wallet';
import 'antd/dist/reset.css';
import {
  Body,
  BtnCancel,
  BtnCreate,
  Content,
  Footer,
  Header,
  ModalContainer,
  Overlay,
} from './styles';
import { transformMaskCurrency } from '../../../../../../../utils/transformMaskCurrency';

interface ModalCriarBoxProps {
  onClose: () => void;
  onCreate: (updatedTotal: string, totalApplied: string) => void;
  loading: boolean;
  totalApplied?: number;
  updatedTotal?: number;
}

export interface IPropsAllPosition extends IPropsPositionAll {
  key: string;
}

export default function ModalUpdateFixedIncome({
  onClose,
  onCreate,
  totalApplied,
  updatedTotal,
  loading,
}: ModalCriarBoxProps) {
  const [value, setValue] = useState<any>(null);
  const [numericValue, setNumericValue] = useState<number>(0);

  const [totalAppliedValue, setTotalAppliedValue] = useState<any>(null);
  const [numericTotalAppliedValue, setNumericTotalAppliedValue] = useState<number>(0);

  useEffect(() => {
    if (updatedTotal) {
      setNumericValue(updatedTotal);
      setValue(transformMaskCurrency(updatedTotal));
    }
    if (totalApplied) {
      setNumericTotalAppliedValue(totalApplied);
      setTotalAppliedValue(transformMaskCurrency(totalApplied));
    }
  }, []);

  const handleTotalAppliedChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numValue = parseFloat(e.target.value) || 0;
    setNumericTotalAppliedValue(numValue);
    setTotalAppliedValue(transformMaskCurrency(numValue));
  };

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numValue = parseFloat(e.target.value) || 0;
    setNumericValue(numValue);
    setValue(transformMaskCurrency(numValue));
  };

  return (
    <Overlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <Header>
          <h3>Atualizar investimento</h3>
        </Header>

        <Body>
          <Content
            style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
          >
            <label>Valor Aplicado</label>
            <input
              className="form-control"
              value={numericTotalAppliedValue}
              type="number"
              step="0.01"
              min="0"
              onChange={handleTotalAppliedChange}
              placeholder="0.00"
            />
            <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
              {totalAppliedValue && <span>Valor formatado: {totalAppliedValue}</span>}
            </div>
          </Content>
          <Content
            style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
          >
            <label>Valor atualizado</label>
            <input
              className="form-control"
              value={numericValue}
              type="number"
              step="0.01"
              min="0"
              onChange={handleNumberChange}
              placeholder="0.00"
            />
            <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
              {value && <span>Valor formatado: {value}</span>}
            </div>
          </Content>
        </Body>

        <Footer>
          <BtnCreate onClick={() => onCreate(numericValue.toString(), numericTotalAppliedValue.toString())} disabled={loading}>
            Salvar
          </BtnCreate>
          <BtnCancel onClick={onClose} disabled={loading}>
            Cancelar
          </BtnCancel>
        </Footer>
      </ModalContainer>
    </Overlay>
  );
}
